export class Message {
  text = null;
  timeout = 0;
  color = "success";

  constructor(text, timeout, color) {
    this.text = text;
    this.timeout = timeout;
    this.color = color;
  }
}
